export default "__VITE_ASSET__952694c7__"